// Create a new context file: src/context/HelmetContext.tsx
import React, { createContext, ReactNode, useContext } from "react";

interface HelmetDexteelContextType {
	navbarTitle: string | null;
}

const HelmetDexteelContext = createContext<
	HelmetDexteelContextType | undefined
>(undefined);

interface HelmetDexteelProviderProps {
	navbarTitle: string | null;
	children: ReactNode;
}

export const HelmetDexteelProvider: React.FC<HelmetDexteelProviderProps> = ({
	navbarTitle,
	children,
}) => {
	return (
		<HelmetDexteelContext.Provider value={{ navbarTitle }}>
			{children}
		</HelmetDexteelContext.Provider>
	);
};

export const useHelmetDexteel = () => {
	const context = useContext(HelmetDexteelContext);
	if (context === undefined) {
		throw new Error("useHelmet must be used within a HelmetProvider");
	}
	return context;
};
